export const coatings = [
    'Antiadherente',
    'Cerámica',
    'Acero',
    'Sin revestimiento'
];
